import { render, staticRenderFns } from "./SettingsColor.vue?vue&type=template&id=f16223c8&scoped=true&"
import script from "./SettingsColor.vue?vue&type=script&lang=js&"
export * from "./SettingsColor.vue?vue&type=script&lang=js&"
import style0 from "./SettingsColor.vue?vue&type=style&index=0&id=f16223c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16223c8",
  null
  
)

export default component.exports